export function cta_trial_locale() {
  const _mlatTrialUrls = (window.mlatConfig && window.mlatConfig.trial && window.mlatConfig.trial.signupUrls) || ['my.jurnal.id/id/users/sign_up', 'my.jurnal.id/en/users/sign_up'];
  var links = document.getElementsByTagName('a');

  if (links.length > 0) {
    for (var i = 0; i < links.length; i++) {
      if (_mlatTrialUrls.some(u => links[i].href.includes(u))) {
        var url = new URL(links[i].href);
        // Deteksi bahasa dari <html lang="...">
        var htmlLang = (document.documentElement.lang || '').toLowerCase();
        var isEn = htmlLang.includes('en') || htmlLang.includes('us');
        var localeVal = isEn ? 'en' : 'id';

        if (!url.searchParams.has('locale')) {
          url.searchParams.set('locale', localeVal);
        }

        links[i].setAttribute('href', url);
      }
    }
  }
}
